import fetch from 'features/common/fetch';

export const NAME = 'entity-campaigns';

export const url = fetch.constants.urls.campaignList;

export const kewWindow = {
	contacts: 'contacts',
	productions: 'productions',
};
